<template>
  <div class="user_main con">
    <div class="user_top">
      <span class="user_topl">当前位置：</span>
      <router-link to="/index"><span class="user_topr">首页 ></span></router-link>
      <span>样音模板</span>
    </div>
    <div class="user_center fn-clear">
      <ul class="user_nav fl demo_nav">
        <li :class="tabindex == index ? 'demo_active' : ''" v-for="(item, index) in demolist" :key="index" @click="tabindex = index">
          {{ item.catsubname }}
        </li>
      </ul>
      <div class="user_demo fr" v-for="(item, index) in demolist" :key="index" v-show="tabindex == index">
        <div class="user_demol">
          <div class="user_demoli" v-for="(item2, index2) in item.samplemusicList" :key="index2" v-show="index2 % 2 == 1">
            <div class="demo_litop">
              <div class="flex_ali">
                <img :src="item2.headpath" alt="" class="demo_avater" />
                <div>
                  <p>{{ item2.smpname }}</p>
                  <p class="demo_anchor">主播：{{ item2.voiceauthor }}</p>
                </div>
              </div>
              <div class="flex_ali">
                <div class="index_mod2_btn" @click="demo_audio.play(item2.musicurl)" :class="demo_audio.audiourl == item2.musicurl ? 'index_mod2_btnact' : ''">
                  <img src="../../assets/images/pause.png" v-if="demo_audio.audiourl == item2.musicurl"/>
                  <img src="../../assets/images/play.png" v-else />
                  <!-- <span>试听</span> -->
                  <span>{{demo_audio.audiourl == item2.musicurl ? "暂停" : "试听"}}</span>
                </div>
                <div class="index_mod2_btn" @click="setDubbingDemo(item2)">
                  <img src="../../assets/images/enit.png" />
                  <span>使用</span>

                </div>
              </div>
            </div>
            <p class="demo_text">
              {{ item2.voicetext }}
            </p>
          </div>
        </div>
        <div class="user_demol">
          <div class="user_demoli" v-for="(item2, index2) in item.samplemusicList" :key="index2" v-show="index2 % 2 !== 1">
            <div class="demo_litop">
              <div class="flex_ali">
                <img :src="item2.headpath" alt="" class="demo_avater" />
                <div>
                  <p>{{ item2.smpname }}</p>
                  <p class="demo_anchor">主播：{{ item2.voiceauthor }}</p>
                </div>
              </div>
              <div class="flex_ali">
                <div class="index_mod2_btn" @click="demo_audio.play(item2.musicurl)" :class="demo_audio.audiourl == item2.musicurl ? 'index_mod2_btnact' : ''">
                  <img src="../../assets/images/pause.png" v-if="demo_audio.audiourl == item2.musicurl"/>
                  <img src="../../assets/images/play.png" v-else />
                  <span>试听</span>
                </div>
                <div class="index_mod2_btn" @click="setDubbingDemo(item2)">
                  <img src="../../assets/images/enit.png" />
                  <span>使用</span>
                </div>
              </div>
            </div>
            <p class="demo_text">
              {{ item2.voicetext }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import PlayListAudio from "../../utils/PlayListAudio.js";
export default {
  name:'demo',
  data() {
    return {
      // tab索引
      tabindex: 0,
      // 样音列表
      demolist: [],
      // 播放器对象
      demo_audio: null,
    };
  },
  computed: {
      ...mapState(["allMusic"]),
  },
  mounted() {
    this.getDubbingDemo();
    this.demo_audio = new PlayListAudio();
  },
  destroyed() {
    this.demo_audio.stop();
  },
  methods: {
    // 获取模板样音
    getDubbingDemo() {
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qrysamplemusicv6;
      this.$request.postHttp({}, url, (decData) => {
        console.log(decData.model);
        self.demolist = decData.model;
      });
    },
    // 使用模板样音
    setDubbingDemo(item) {
        console.log(item)
      this.demo_audio.stop();
      let self = this;
      let bg_music = this.$globalFun.detection(this.allMusic,item.bgmusic);
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryzhubodetail;
      this.$request.postHttp({ zbid: item.zbid }, url, (decData) => {
          console.log(decData)
          if(!decData.model){
              this.$message.error('主播信息异常！');
              return
          }
        this.$store.commit("setAnchor", decData.model);
        this.$router.push({
          path: "/make",
          query: {
            voicetext: item.voicetext,
            bg_music: bg_music,
          },
        });
      });
    },
  },
  watch: {
    $route(to, from) {
      this.demo_audio.stop();
    },
  },
};
</script>
<style>
@import url("../../assets/css/user.css");
</style>



// WEBPACK FOOTER //
// src/view/dubbing/demo.vue